import { cn } from '@/lib/utils';

/**
 * Logo Consalud al inicio del caso, de la pregunta y bajo cada inciso (como el legacy en
 * `talleres/taller/pestanias/casoclinico.php`), para que un caso copiado lleve la marca.
 * - `tema`: color en tema claro y blanco en oscuro (sobre `superficie-lectura`).
 * - `blanco`: siempre blanco (barra de pregunta, letra del inciso).
 */
export function LogoCaso({
  variante = 'tema',
  className,
}: {
  variante?: 'tema' | 'blanco';
  className?: string;
}) {
  const clase = cn('pointer-events-none inline-block h-4 w-auto select-none', className);
  if (variante === 'blanco')
    return <img src="/img/consalud-horizontal-blanco.png" alt="ConsaludENARM" className={clase} />;
  return (
    <>
      <img
        src="/img/consalud-horizontal-color.png"
        alt="ConsaludENARM"
        className={cn(clase, 'solo-claro')}
      />
      <img
        src="/img/consalud-horizontal-blanco.png"
        alt="ConsaludENARM"
        className={cn(clase, 'solo-oscuro')}
      />
    </>
  );
}
